import { Component, computed, DestroyRef, inject, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { EntitlementLevelEnum, EntitlementsService, FeatureMappingEnum } from '@unified-ui/entitlements';
import { BuilderManagerService, BuilderMode } from '@unified-ui/shared/services';
import { ThemeService } from '@unified-ui/theme';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

@Component({
    selector: 'unified-ui-landing-page',
    standalone: true,
    imports: [ButtonModule, RouterModule, MenuModule],
    templateUrl: './landing-page.component.html',
    styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent {
    private _router = inject(Router);
    private _themeService = inject(ThemeService);
    private _builderManagerService = inject(BuilderManagerService);
    private _entitlementsService = inject(EntitlementsService);

    public theme: Signal<string> = computed(() => {
        return this._themeService.theme();
    });

    private _destroyRef = inject(DestroyRef);

    /**
     * Menu items for builder button
     */
    protected builderItems: MenuItem[] = [];

    /**
     * Manu items for report list button
     */
    protected reportItems: MenuItem[] = [];

    constructor() {
        this._entitlementsService.ready$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(ready => {
            if (ready) this._buildButtonMenus();
        });
    }

    /**
     * Build menu items considering entitlements
     */
    private _buildButtonMenus() {
        this.builderItems = [
            // ...(this._entitlementsService.hasEntitlement(FeatureMappingEnum.DATA_SOLUTIONS, EntitlementLevelEnum.REPORT) ?
            //     [
            //         {
            //             label: 'Data Solutions Report Builder',
            //             icon: 'pi pi-database',
            //             command: () => {
            //                 // Import both the ReportChooserComponent and MediaScopeBuilderService
            //                 import('@mediascope/report-chooser').then(reportChooserModule => {
            //                     // Set the state for the builder
            //                     this._builderManagerService.state = {
            //                         open: true,
            //                         mode: BuilderMode.NEW,
            //                         firstOpening: true,
            //                         templateStep: BuilderTemplate.CHOOSER,
            //                         builderComponent: reportChooserModule.ReportChooserComponent
            //                     };
            //                     this._router.navigate(['/data-solutions']);
            //                 });
            //             }
            //         }
            //     ]
            // :   []),
            ...(this._entitlementsService.hasEntitlement(FeatureMappingEnum.PLANNING, EntitlementLevelEnum.REPORT) ?
                [
                    {
                        label: 'Guideline Planning Report Builder',
                        icon: 'pi g-chart-data',
                        command: () => {
                            // Import builder component from mt-reporter
                            import('@planning/feature/mt-reporter-lib').then(mtReporterComponents => {
                                this._router.navigate(['/planning']);
                                // Set it in the builder manager
                                const mtReporterBuilderComponent = mtReporterComponents.BuilderComponent;
                                this._builderManagerService.state = { builderComponent: mtReporterBuilderComponent, open: true, mode: BuilderMode.NEW };
                            });
                        }
                    }
                ]
            :   [])
        ];

        this.reportItems = [
            // ...(this._entitlementsService.hasEntitlement(FeatureMappingEnum.DATA_SOLUTIONS, EntitlementLevelEnum.REPORT) ?
            //     [
            //         {
            //             label: 'Data Solutions Saved Reports',
            //             icon: 'pi pi-database',
            //             command: () => {
            //                 this._router.navigate(['/data-solutions']);
            //             }
            //         }
            //     ]
            // :   []),
            ...(this._entitlementsService.hasEntitlement(FeatureMappingEnum.PLANNING, EntitlementLevelEnum.REPORT) ?
                [
                    {
                        label: 'Guideline Planning Saved Reports',
                        icon: 'pi g-chart-data',
                        command: () => {
                            this._router.navigate(['/planning']);
                        }
                    }
                ]
            :   [])
        ];
    }
}
